<template>
  <section id="faq-view" class="enterprise-section enterprise-faq" aria-labelledby="enterprise-faq-title">
    <div class="enterprise-shell enterprise-faq__shell">
      <div class="enterprise-section-heading">
        <h2 id="enterprise-faq-title">{{ t('enterprise_home_nav_faq') }}</h2>
        <p>{{ t('enterprise_home_faq_description') }}</p>
      </div>

      <div class="enterprise-faq__list">
        <details v-for="item in faqs" :key="item.question" name="enterprise-faq">
          <summary>
            <strong>{{ item.question }}</strong>
            <span class="enterprise-faq__toggle" aria-hidden="true">
              <EnterpriseIcon class="enterprise-faq__plus" :src="plusIcon" />
              <EnterpriseIcon class="enterprise-faq__minus" :src="minusIcon" />
            </span>
          </summary>
          <p>{{ item.answer }}</p>
        </details>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import EnterpriseIcon from '~/components/Index/enterprise/EnterpriseIcon.vue'
import minusIcon from '~/assets/images/enterprise/icons/minus.svg'
import plusIcon from '~/assets/images/enterprise/icons/plus.svg'
import { getEnterpriseFaqs } from '~/config/enterpriseLanding'
import { useSiteConfig } from '~/config/useSiteConfig'

const { siteEdition } = useSiteConfig()
const { contactEmail } = useAppDomainConfig()
const { t } = useI18n()
const faqs = computed(() => getEnterpriseFaqs(siteEdition.value, contactEmail.value, t))
</script>
